<template>
	<span :class="['badge-count', classVariation]">
		{{ value }}
	</span>
</template>

<script>
export default {
	name: 'BadgeCount',

	props: {
		value: {
			type: [String, Number],
			default: null
		},
		variant: {
			type: String,
			default: 'neutral'
		}
	},

	computed: {
		colorClassVariation() {
			const classMap = {
				positive: 'badge-count--positive',
				negative: 'badge-count--negative',
				warning: 'badge-count--warning',
				'secondary-1': 'badge-count--secondary-1',
				'secondary-2': 'badge-count--secondary-2',
				'secondary-3': 'badge-count--secondary-3',
				'secondary-4': 'badge-count--secondary-4',
				default: ''
			};

			return {
				class: classMap[this.variant] || classMap['default']
			};
		},
		classVariation() {
			return this.colorClassVariation.class;
		}
	}
};
</script>

<style lang="scss">
/**
    * Badge Count - Reusable counter for elements
*/

.badge-count {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	height: 18px;
	min-width: 18px;
	padding-left: 6px;
	padding-right: 6px;
	border-radius: 12px;
	@include text-contrast($ui-neutral, $white, $black);
	font-weight: $medium-font-weight;
	font-size: $default-font-size - 5;
	border: 1px solid $white;
	background-color: $ui-neutral;

	&--absolute {
		position: absolute;
	}

	&--positive {
		background-color: $ui-positive;
		color: $white;
	}

	&--negative {
		background-color: $ui-negative;
		color: $white;
	}

	&--warning {
		background-color: $ui-warning;
		@include text-contrast($ui-warning, $white, $black);
	}

	&--secondary-1 {
		background-color: $ui-secondary-1;
		color: $white;
		@include text-contrast($ui-secondary-1, $white, $black);
	}

	&--secondary-2 {
		background-color: $ui-secondary-2;
		color: $white;
	}

	&--secondary-3 {
		background-color: $ui-secondary-3;
		color: $white;
		@include text-contrast($ui-secondary-3, $white, $black);
	}

	&--secondary-4 {
		background-color: $ui-secondary-4;
		color: $white;
		@include text-contrast($ui-secondary-4, $white, $black);
	}
}
</style>
